const locale: Locale = {
  ko: {
    about: '이용안내',
    petition: '청원하기',
    all: '모든 청원',
    answered: '답변된 청원',
  },
  en: {
    about: 'About',
    petition: 'New Petition',
    all: 'Browse',
    answered: 'Responded',
  },
}

export default locale
